module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Communication/Outgoing-mail-4de3664b77455d13ed55562f2d49886e.svg";